import type { RequestOptions } from '@@/plugin-request/request';
import { request as umiRequest } from '@umijs/max';
import { BizAppConfig } from 'config/application.manifest';

type ScopedRequestOptions = RequestOptions;

export function createRequest(baseURL?: string | (() => string | undefined)) {
  return <T = unknown>(url: string, options?: ScopedRequestOptions) => {
    const rawBaseURL = typeof baseURL === 'function' ? baseURL() : baseURL;
    const scopedBaseURL =
      rawBaseURL ??
      (typeof BizAppConfig !== 'undefined' ? BizAppConfig?.appApiUrl : '') ??
      '';
    const nextOptions: ScopedRequestOptions = { ...(options || {}) };

    return (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>
    )<T>(url, {
      baseURL: scopedBaseURL,
      ...nextOptions,
    });
  };
}

export function createAppRequest() {
  return createRequest(() => BizAppConfig?.appApiUrl);
}

export function createTenantManagementRequest() {
  return createRequest(() => BizAppConfig?.appTenantManagementUrl);
}
